import { getFiNode } from './fiNode';
export class FiEdge {
    constructor(mEdge) {
        this._length = 1;
        this.mEdge = mEdge;
        this.sourceFiNode = getFiNode(this.mEdge.source);
        this.targetFiNode = getFiNode(this.mEdge.target);
    }
    get source() {
        return this.sourceFiNode.index;
    }
    get target() {
        return this.targetFiNode.index;
    }
    get length() {
        return this._length;
    }
    set length(value) {
        this._length = value;
    }
    vector() {
        return this.sourceFiNode.geomNode.center.sub(this.targetFiNode.geomNode.center);
    }
}
//# sourceMappingURL=fiEdge.js.map